<template>
    <div>
        <SearchBox ref="SearchBox">
            <template slot="form">
                <div class="selectInfo">
                    <div style="display: flex; flex-wrap: wrap">
                        <span class="topSty" style="font-size: 1.1vw; flex: 1">点检看板</span>
                        <div class="topsele">
                            <div class="topSty">
                                <span>工厂：</span>
                                <el-select v-model="fcIdSelected" placeholder="请选择" :clearable="isclear" :disabled="ischeck" filterable @change="fcChange">
                                    <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label" :value="factory.value"></el-option>
                                </el-select>
                            </div>
                            <div class="topSty">
                                <span>车间：</span>
                                <el-select v-model="shopSelected" placeholder="请选择" clearable filterable @change="shopChange">
                                    <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label" :value="shop.value"></el-option>
                                </el-select>
                            </div>
                            <div class="topSty">
                                <span>工段：</span>
                                <el-select v-model="sectionSelected" placeholder="请选择" clearable filterable @change="sectionChange">
                                    <el-option v-for="section in sectionList" :key="section.value" :label="section.label" :value="section.value"></el-option>
                                </el-select>
                            </div>
                            <div class="topSty">
                                <span>产线：</span>
                                <el-select v-model="lineSelected" placeholder="请选择" clearable filterable @change="lineChange">
                                    <el-option v-for="line in lineList" :key="line.value" :label="line.label" :value="line.value"></el-option>
                                </el-select>
                            </div>
                            <div class="topSty">
                                <span>点检时间：</span>
                                <el-date-picker v-model="timeValue" type="date" placeholder="选择日期"></el-date-picker>
                            </div>
                            <div class="topSty" style="margin-top: 20px">
                                <el-button type="primary" @click="getDailyCheckQuantity">手动刷新</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </SearchBox>
        <SearchBox ref="SearchBox">
            <template slot="form">
                <!--<div style="margin: 0 0 1vw 0">
                    <p style="margin-left:1vw;;text-align:left;">早班</p>
                    <div style="display: flex;" class="Sty1">
                        <div style="flex: 1;display: flex;justify-content:center;width:100%"
                             v-for="(item, index) in searchMorningData" @click="activeBtn(item)">
                            <div style="width:25%;" :style="getStyle(item)">
                                <p>{{ item.title }}</p>
                                <h3 class="Sty1 styColor1">{{ item[index] }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <hr/>
                <div style="margin: 0 0 1vw 0">
                    <p style="margin: 0.3vw 0 0 1vw;text-align:left;">晚班</p>
                    <div style="display: flex" class="Sty1">
                        <div style="flex: 1;display: flex;justify-content:center;width:100%"
                             v-for="(item, index) in searchNightData" @click="activeBtn(item)">
                            <div style="width:25%;" :style="getStyle(item)">
                                <p>{{ item.title }}</p>
                                <h3 class="Sty1 styColor1">{{ item[index] }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <hr/>-->
                <div style="margin: 0 0 1vw 0">
                    <!--<p style="margin-left:1vw;;text-align:left;">早班</p>-->
                    <div style="display: flex" class="Sty1">
                        <div style="flex: 1; display: flex; justify-content: center; width: 100%">
                            <div style="width:25%;">
                                <p>总产线数</p>
                                <h3 class="Sty1 styColor1">{{searchData.dailyTotalLines}}</h3>
                            </div>
                            <div style="width: 25%">
                                <p>点检产线数</p>
                                <h3 class="Sty1 styColor1">{{ searchData.dailyLines }}</h3>
                            </div>
                            <div style="width:25%;">
                                <p>总设备数</p>
                                <h3 class="Sty1 styColor1">{{searchData.dailyDeviceTotal}}</h3>
                            </div>
                            <div style="width: 25%">
                                <p>点检设备数</p>
                                <h3 class="Sty1 styColor1">{{ searchData.dailyDevices }}</h3>
                            </div>
                            <div style="width: 25%">
                                <p>总开班点检数</p>
                                <h3 class="Sty1 styColor1">{{ searchData.dailyTotal }}</h3>
                            </div>
                            <div style="width: 25%">
                                <p>完成开班点检数</p>
                                <h3 class="Sty1 styColor1">{{ searchData.dailyComp }}</h3>
                            </div>
                            <div style="width: 25%">
                                <p>开班点检完成率</p>
                                <h3 class="Sty1 styColor1">{{ searchData.dailyCompRate }}%</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </SearchBox>
        <div class="currentState">
            <el-table stripe :data="tableData" style="width: 100%" @current-change="dailyCurrentChange">
                <el-table-column prop="dcoId" label="点检编号" align="center"></el-table-column>
                <el-table-column prop="sfName" label="点检类型" align="center"></el-table-column>
                <el-table-column prop="dailyNums" label="点检数量" align="center"></el-table-column>
                <el-table-column prop="dailyCompNums" label="完成数量" align="center"></el-table-column>
                <el-table-column prop="dailyNorNums" label="点检异常数量" align="center" width="130"></el-table-column>
                <el-table-column prop="shiftOfferStartTime" label="点检时间" align="center" width="160"></el-table-column>
                <el-table-column prop="fcName" label="工厂" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="shopName" label="车间" align="center"></el-table-column>
                <el-table-column prop="sectionName" label="工段" align="center"></el-table-column>
                <el-table-column prop="lineName" label="产线" align="center"></el-table-column>
                <el-table-column prop="devCode" label="设备号" align="center"></el-table-column>
                <el-table-column prop="devName" label="设备名称" align="center"></el-table-column>
                <!--                    <el-table-column prop="examine" label="点检人" align="center"> </el-table-column>-->
            </el-table>
            <el-pagination
                style="margin-top: 3vh"
                background
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import { dailyCheckPage, dailyCheckQuantity, dailyCheckQuantityPage } from '../../../libs/api'

    export default {
        data () {
            return {
                tableData: [],
                factoryTree: [],
                fcIdSelected: '',
                sectionSelected: '',
                shopSelected: '',
                lineSelected: '',
                timeValue: new Date(),
                userInfo: {},
                role: {},
                ischeck: true,
                isclear: false,
                isChange: true,
                searchMorningData: [],
                searchNightData: [],
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                searchData: {},
                selectType: '',
                shiftId: '',
                shiftItem: {},
                intervalId: null
            }
        },
        computed: {
            factoryList: function () {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0;i < this.factoryTree.length;i++) {
                            for (let j = 0;j < userInfo.roles.length;j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0;i < this.factoryTree.length;i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function () {
                var arr = []
                if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                    var factory = JSON.parse(this.fcIdSelected)
                    var shops = factory.child
                    for (var i = 0;i < shops.length;i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function () {
                var arr = []
                if (this.shopSelected != undefined && this.shopSelected.length > 0) {
                    var shop = JSON.parse(this.shopSelected)
                    var vsms = shop.child
                    for (var i = 0;i < vsms.length;i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function () {
                var arr = []
                if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                    var vsm = JSON.parse(this.sectionSelected)
                    var lines = vsm.child
                    for (var i = 0;i < lines.length;i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        destroyed () {
            // 在页面销毁后，清除计时器
            this.clear()
        },
        created () {
            this.dataRefreh()
        },
        mounted () {
            this.init()
        },
        methods: {
            init () {
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0;i < role.length;i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getData()
            },
            // 定时刷新数据函数
            dataRefreh () {
                // 计时器正在进行中，退出函数
                if (this.intervalId != null) {
                    return
                }
                // 计时器为空，操作
                this.intervalId = setInterval(() => {
                    console.log('刷新' + new Date())
                    this.getDailyCheckQuantity() //加载数据函数
                }, 5000)
            },
            // 停止定时器
            clear () {
                clearInterval(this.intervalId) //清除计时器
                this.intervalId = null //设置为null
            },
            fcChange: function () {
                this.isChange = false
                this.shopSelected = ''
                this.sectionSelected = ''
                this.lineSelected = ''
                this.getDailyCheckQuantity()
            },
            shopChange: function () {
                this.sectionSelected = ''
                this.lineSelected = ''
                this.getDailyCheckQuantity()
            },
            sectionChange: function () {
                this.lineSelected = ''
                this.getDailyCheckQuantity()
            },
            lineChange: function () {
                this.getDailyCheckQuantity()
            },
            dailyCurrentChange (row) {
                var array = JSON.parse(JSON.stringify(row))
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    array['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                if (this.shopSelected != undefined && this.shopSelected != '') {
                    array['shopCode'] = JSON.parse(this.shopSelected).deptCode
                }
                if (this.sectionSelected != undefined && this.sectionSelected != '') {
                    array['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
                }
                if (this.lineSelected != undefined && this.lineSelected != '') {
                    array['lineCode'] = JSON.parse(this.lineSelected).deptCode
                }
                this.$router.push({
                    name: 'dailyCheckOrder',
                    params: {
                        daiExamine: array
                    }
                })
            },
            paginationChange (val) {
                this.searchParams.pageSize = val
                this.getDailyCheckQuantityPage()
            },
            paginationCurrentChange (val) {
                this.searchParams.page = val
                this.getDailyCheckQuantityPage()
            },
            getStyle (item) {
                if (item.isActive) {
                    return {
                        'border-radius': '5px',
                        'border': '1px red solid'
                    }
                }
                return {}
            },
            activeBtn (item) {
                var arr = []
                for (let i = 0;i < this.searchMorningData.length;i++) {
                    arr.push(this.searchMorningData[i])
                }
                for (let j = 0;j < this.searchNightData.length;j++) {
                    arr.push(this.searchNightData[j])
                }
                let currentState = item.isActive
                arr.forEach(el => {
                    el.isActive = false
                })
                item.isActive = !currentState
                if (item.isActive == undefined || item.isActive == '') {
                    return
                }
                this.shiftItem = item
                this.selectType = item.selectType
                this.shiftId = item.shiftId
                this.$nextTick(() => {
                    this.getDailyCheckPage()
                })
            },
            getDailyCheckTotality () {
                let queryParams = {}
                var self = this
                if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
                }
                if (self.shopSelected != undefined && self.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
                }
                if (self.sectionSelected != undefined && self.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                }
                if (self.lineSelected != undefined && self.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
                }
                if (self.timeValue != undefined && self.timeValue != '') {
                    queryParams['mothDate'] = moment(self.timeValue).format('YYYY-MM-DD')
                } /*else {
                    queryParams['mothDate'] = moment(new Date()).format('YYYY-MM-DD')
                }*/
                let options = {
                    method: 'get',
                    url: this.$api.dailyCheckTotality,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            var array = response.data
                            var morningArr = []
                            var morId = ''
                            var nightArr = []
                            for (let i = 0;i < array.length;i++) {
                                if (array[i].shiftName.search('早') != -1) {
                                    morId = JSON.parse(JSON.stringify(array[i])).shiftId
                                    morningArr = [
                                        {
                                            0: JSON.parse(JSON.stringify(array[i])).todayCheckAmount,
                                            title: '今日点检数',
                                            isActive: false,
                                            shiftId: JSON.parse(JSON.stringify(array[i])).shiftId,
                                            shiftName: JSON.parse(JSON.stringify(array[i])).shiftName,
                                            selectType: 'A'
                                        },
                                        {
                                            1: JSON.parse(JSON.stringify(array[i])).offerCompleteAmount,
                                            title: '开班点检数',
                                            isActive: false,
                                            shiftId: JSON.parse(JSON.stringify(array[i])).shiftId,
                                            shiftName: JSON.parse(JSON.stringify(array[i])).shiftName,
                                            selectType: 'B'
                                        },
                                        {
                                            2: JSON.parse(JSON.stringify(array[i])).offerUnCompleteAmount,
                                            title: '开班未完成数',
                                            isActive: false,
                                            shiftId: JSON.parse(JSON.stringify(array[i])).shiftId,
                                            shiftName: JSON.parse(JSON.stringify(array[i])).shiftName,
                                            selectType: 'C'
                                        }/*,
                                  {
                                      3: JSON.parse(JSON.stringify(array[i])).closeCompleteAmount,
                                      title: '班后已完成数',
                                      isActive: false,
                                      shiftId: JSON.parse(JSON.stringify(array[i])).shiftId,
                                      shiftName: JSON.parse(JSON.stringify(array[i])).shiftName,
                                      selectType: 'D'
                                  },
                                  {
                                      4: JSON.parse(JSON.stringify(array[i])).closeUnCompleteAmount,
                                      title: '班后未完成数',
                                      isActive: false,
                                      shiftId: JSON.parse(JSON.stringify(array[i])).shiftId,
                                      shiftName: JSON.parse(JSON.stringify(array[i])).shiftName,
                                      selectType: 'E'
                                  }*/
                                    ]
                                } else if (array[i].shiftName.search('晚') != -1) {
                                    nightArr = [
                                        {
                                            0: JSON.parse(JSON.stringify(array[i])).todayCheckAmount,
                                            title: '今日点检数',
                                            isActive: false,
                                            shiftId: JSON.parse(JSON.stringify(array[i])).shiftId,
                                            shiftName: JSON.parse(JSON.stringify(array[i])).shiftName,
                                            selectType: 'A'
                                        },
                                        {
                                            1: JSON.parse(JSON.stringify(array[i])).offerCompleteAmount,
                                            title: '开班点检数',
                                            isActive: false,
                                            shiftId: JSON.parse(JSON.stringify(array[i])).shiftId,
                                            shiftName: JSON.parse(JSON.stringify(array[i])).shiftName,
                                            selectType: 'B'
                                        },
                                        {
                                            2: JSON.parse(JSON.stringify(array[i])).offerUnCompleteAmount,
                                            title: '开班未完成数',
                                            isActive: false,
                                            shiftId: JSON.parse(JSON.stringify(array[i])).shiftId,
                                            shiftName: JSON.parse(JSON.stringify(array[i])).shiftName,
                                            selectType: 'C'
                                        }/*,
                                  {
                                      3: JSON.parse(JSON.stringify(array[i])).closeCompleteAmount,
                                      title: '班后已完成数',
                                      isActive: false,
                                      shiftId: JSON.parse(JSON.stringify(array[i])).shiftId,
                                      shiftName: JSON.parse(JSON.stringify(array[i])).shiftName,
                                      selectType: 'D'
                                  },
                                  {
                                      4: JSON.parse(JSON.stringify(array[i])).closeUnCompleteAmount,
                                      title: '班后未完成数',
                                      isActive: false,
                                      shiftId: JSON.parse(JSON.stringify(array[i])).shiftId,
                                      shiftName: JSON.parse(JSON.stringify(array[i])).shiftName,
                                      selectType: 'E'
                                  }*/
                                    ]
                                }
                            }
                            self.searchMorningData = morningArr
                            self.searchNightData = nightArr
                            if (self.shiftItem.shiftName != undefined && self.shiftItem.shiftName != '') {
                                var morNightId = ''
                                var morNightType = ''
                                if (self.shiftItem.shiftName.search('早') != -1) {
                                    for (let i = 0;i < self.searchMorningData.length;i++) {
                                        if (self.shiftItem.title == self.searchMorningData[i].title) {
                                            self.searchMorningData[i].isActive = self.shiftItem.isActive
                                            morNightType = self.searchMorningData[i].selectType
                                        }
                                        morNightId = self.searchMorningData[i].shiftId
                                    }
                                }
                                if (self.shiftItem.shiftName.search('晚') != -1) {
                                    for (let j = 0;j < self.searchNightData.length;j++) {
                                        if (self.shiftItem.title == self.searchNightData[j].title) {
                                            self.searchNightData[j].isActive = self.shiftItem.isActive
                                            morNightType = self.searchNightData[j].selectType
                                        }
                                        morNightId = self.searchNightData[j].shiftId
                                    }
                                }
                                self.shiftId = morNightId
                                self.selectType = morNightType
                            } else {
                                self.searchMorningData[0].isActive = true
                                self.selectType = 'A'
                                self.shiftId = morId
                            }
                            self.getDailyCheckPage()
                        } else {
                            self.dataClear()
                        }
                    } else {
                        self.dataClear()
                    }
                })
            },
            getDailyCheckPage () {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                var self = this
                if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
                }
                if (self.shopSelected != undefined && self.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
                }
                if (self.sectionSelected != undefined && self.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                }
                if (self.lineSelected != undefined && self.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
                }
                if (self.timeValue != undefined && self.timeValue != '') {
                    queryParams['mothDate'] = moment(self.timeValue).format('YYYY-MM-DD')
                } /*else {
                    queryParams['mothDate'] = moment(new Date()).format('YYYY-MM-DD')
                }*/
                if (self.selectType != undefined && self.selectType != '') {
                    queryParams['selectType'] = self.selectType
                }
                if (self.shiftId != undefined && self.shiftId != '') {
                    queryParams['siftId'] = self.shiftId
                }
                let options = {
                    method: 'GET',
                    url: this.$api.dailyCheckPage,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            getDailyCheckQuantity () {
                let queryParams = {}
                var self = this
                if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
                }
                if (self.shopSelected != undefined && self.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
                }
                if (self.sectionSelected != undefined && self.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                }
                if (self.lineSelected != undefined && self.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
                }
                if (self.timeValue != undefined && self.timeValue != '') {
                    queryParams['mothDate'] = moment(self.timeValue).format('YYYY-MM-DD')
                } /*else {
                    queryParams['mothDate'] = moment(new Date()).format('YYYY-MM-DD')
                }*/
                let options = {
                    method: 'get',
                    url: this.$api.dailyCheckQuantity,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            self.searchData = response.data
                            self.getDailyCheckQuantityPage()
                        } else {
                            self.dataClear()
                        }
                    } else {
                        self.dataClear()
                    }
                })
            },
            getDailyCheckQuantityPage () {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                var self = this
                if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
                }
                if (self.shopSelected != undefined && self.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
                }
                if (self.sectionSelected != undefined && self.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                }
                if (self.lineSelected != undefined && self.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
                }
                if (self.timeValue != undefined && self.timeValue != '') {
                    queryParams['mothDate'] = moment(self.timeValue).format('YYYY-MM-DD')
                } /*else {
                    queryParams['mothDate'] = moment(new Date()).format('YYYY-MM-DD')
                }*/
                let options = {
                    method: 'GET',
                    url: this.$api.dailyCheckQuantityPage,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            dataClear () {
                var self = this
                self.searchMorningData = []
                self.searchNightData = []
                self.shiftItem = {}
                self.tableData = []
                self.searchParams = {}
                self.searchData = {}
            },
            getData () {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0;i < self.factoryTree.length;i++) {
                        if (this.ischeck && this.isChange) {
                            if (self.factoryTree[i].deptID == self.role.factoryId) {
                                self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                            }
                        } else if (!this.ischeck && this.isChange) {
                            self.fcIdSelected = JSON.stringify(self.factoryTree[0])
                        }

                    }
                    this.getDailyCheckQuantity()
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .searchBox {
        display: inherit;
    }

    .topsele {
        flex: 10;
        display: flex;
        flex-wrap: wrap;
        margin-top: -20px;
        div {
            margin-top: 10px;
        }
    }
    .selectInfo {
        width: 100%;
        padding: 0.1px;
        text-align: left;
    }

    .topSty {
        margin-left: 2vw;
    }

    .Sty1 {
        text-align: center;
        margin-top: 1vh;
    }

    .styColor1 {
        color: #8bafe3;
    }

    hr {
        background-color: #ccc;
        height: 1px;
        border: none;
    }

    .currentState {
        width: 98%;
        margin: 2vh 1vw 1vh 1vw;
    }
</style>
